<ng-container [ngSwitch]="value">
  <span i18n="TierName.Notes@@tier-i-a" *ngSwitchCase="tierNames.IA">Tier I-A</span>
  <span i18n="TierName.Notes@@tier-i-b" *ngSwitchCase="tierNames.IB">Tier I-B</span>
  <span i18n="TierName.Notes@@tier-ii-c" *ngSwitchCase="tierNames.IIC">Tier II-C</span>
  <span i18n="TierName.Notes@@tier-ii-d" *ngSwitchCase="tierNames.IID">Tier II-D</span>
  <span i18n="TierName.Notes@@tier-iii-vus" *ngSwitchCase="tierNames.III">Tier III (VUS)</span>
  <span i18n="TierName.Notes@@tier-iv" *ngSwitchCase="tierNames.IV">Tier IV</span>
  <span i18n="TierName.Notes@@unclassified" *ngSwitchCase="tierNames.UNCLASSIFIED">Unclassified</span>
</ng-container>
